<template>
  <div>
    <div class="level">
      <div class="level-left">
        <router-link
          class="button is-info is-small"
          :to="{ name: 'Create New Purchase Order' }"
        >
          <span class="icon"> <i class="fas fa-plus"></i> </span>&nbsp; Create
          new</router-link
        >
        &nbsp;
        <button class="button is-small" @click="refreshTable()">Refresh</button>
      </div>
      <div class="level-right">
        <b-select size="is-small" v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="100">100 per page</option>
          <option value="200">200 per page</option>
          <option value="300">300 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>
      </div>
    </div>
    <table-pagination
      :tableData="purchaseOrders.data"
      :search="search"
      :bordered="true"
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :mobileCards="true"
      :loading="isLoadingTable"
      :page="page"
      :perPage="perPage"
      :totalData="purchaseOrders.totalData"
      @onPageChanged="page = $event"
      @onSearchChanged="search = $event"
      @onPerPageChanged="perPage = $event"
      :placeholder="'Search by Supplier, Client & P.O #'"
    >
      <template slot="row-content" slot-scope="{ item }">
        <b-table-column class="table-column-content-is-small" label="P.O #">
          {{ item.row.poNum }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Supplier">
          {{ item.row.supplier }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Client">
          {{ item.row.client }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="P.O date">
          {{ item.row.poDate }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Date created"
        >
          {{ item.row.dateCreated }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Status">
          {{ item.row.poStatus }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Total Amount"
          style="text-align: right"
        >
          {{ item.row.total }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <button
            :class="buttonDownloadPoRequest"
            @click="
              downloadPdf(
                item.row.purchaseOrderId,
                item.row.poNum,
                item.row.supplier
              )
            "
            title="Download PDF"
          >
            <span class="icon">
              <i class="far fa-file-pdf"></i>
            </span>
          </button>
          &nbsp;
          <button
            class="button is-small"
            @click="openHistoryLog(item.row.history)"
            title="View history log"
          >
            <i class="fas fa-history"></i>
          </button>
          &nbsp;
          <router-link
            class="button is-small is-warning"
            :to="{
              name: 'Edit Purchase Order',
              params: { purchaseOrderId: item.row.purchaseOrderId },
            }"
            >Edit/View</router-link
          >
          &nbsp;
          <button
            v-if="hasAdminSalesOrSalesPoStaffPriv"
            class="button is-small is-danger"
            @click="deletePo(item.row.purchaseOrderId, item.row.poNum)"
          >
            Delete
          </button>
        </b-table-column>
      </template>
    </table-pagination>
    <Delete />
    <HistoryLog />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TablePagination from "../TablePagination.vue";
import Delete from "./Delete.vue";
import HistoryLog from "./HistoryLog.vue";
import AppButton from "../frontend/appButton";
import axios from "axios";
import AuthService from "../../_services/auth";
const authService = new AuthService();
const appButton = new AppButton();

export default {
  components: {
    TablePagination,
    Delete,
    HistoryLog,
  },
  mounted() {
    this.default();
  },
  computed: {
    ...mapState("purchaseorder", {
      purchaseOrders: (state) => state.purchaseOrders,
      isLoadingTable: (state) => state.isLoadingTable,
    }),
  },
  data: () => ({
    isEmpty: false,
    page: 1,
    perPage: 10,
    search: "",
    hasAdminSalesOrSalesPoStaffPriv: authService.hasAdminSalesOrSalesPoStaffPriv(),
    buttonDownloadPoRequest: appButton.isLoadingDefault(false),
  }),
  methods: {
    ...mapActions("purchaseorder", [
      "getPaginatedPos",
      "openDeleteModal",
      "openHistoryLogModal",
    ]),
    openHistoryLog(historyLog) {
      this.openHistoryLogModal({
        showHistoryLog: true,
        historyLog: historyLog,
      });
    },
    refreshTable() {
      this.default();
    },
    downloadPdf(id, poNumber, supplier) {
      if (id) {
        this.buttonDownloadPoRequest = appButton.isLoadingDefault(true);
        axios
          .get(`downloadables/purchaseorder?id=${id}`, {
            responseType: "blob",
          })
          .then((response) => {
            console.log(response.data);
            const windowUrl = window.URL || window.webkitURL;
            const url = windowUrl.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `P.O - ${supplier} (${poNumber}).pdf`
            );
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            console.log(error);
          })
          .then(
            () =>
              (this.buttonDownloadPoRequest = appButton.isLoadingDefault(false))
          );
      }
    },
    default() {
      this.getPaginatedPos({
        page: this.page,
        pageSize: this.perPage,
        query: this.search,
      });
    },
    deletePo(id, poNum) {
      this.openDeleteModal({
        showDeleteModal: true,
        purchaseOrder: {
          purchaseOrderId: id,
          poNum: poNum,
        },
      });
    },
  },
  watch: {
    perPage(val) {
      this.getPaginatedPos({
        page: this.page,
        pageSize: val,
        query: this.search,
      });
    },
    page(val) {
      this.getPaginatedPos({
        page: val,
        pageSize: this.perPage,
        query: this.search,
      });
    },
    search(val) {
      this.getPaginatedPos({
        page: this.page,
        pageSize: this.perPage,
        query: val,
      });
    },
  },
};
</script>

